<template>
  <v-tooltip top v-if="quantidadeProdutos > 0">
    <template v-slot:activator="{ on }">
      <v-icon color="primary"
              v-on="on"
              :class="iconClass"
              :small="small">
        mdi-shield-check
      </v-icon>
    </template>
    <span>{{ tooltipIsHomologado }}</span>
  </v-tooltip>
</template>
<script>
import { isFornecedorHomologado } from '@/utils/fornecedor-produto-utils';

export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    idFornecedor: {
      type: [Number, String],
      default: null,
    },
    produtos: {
      type: Array,
      default: () => [],
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasProdutos() {
      return this.produtos && this.produtos.length;
    },
    tooltipIsHomologado() {
      return this.quantidadeProdutos > 1 ? `${this.quantidadeProdutos} produtos homologados ao fornecedor` : `${this.quantidadeProdutos} produto homologado ao fornecedor`;
    },
    quantidadeProdutos() {
      if (!this.hasProdutos) {
        return 0;
      }
      const filteredProdutos = this.produtos.filter(p => this.filtroProdutos(p));
      return filteredProdutos.length;
    },
  },
  methods: {
    filtroProdutos(p) {
      const { fornecedoresProduto } = p.produto;
      if (!fornecedoresProduto || !fornecedoresProduto.length || !this.idFornecedor) {
        return false;
      }
      return isFornecedorHomologado(fornecedoresProduto, this.idFornecedor);
    },
  },
};
</script>
